<template>
    <div>
        <div style="justify-content: space-between" class="center">
            <el-select class="select" v-model="location" size="small" placeholder="类型">
                <el-option v-for="item of locationOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div class="refresh"></div>
        </div>
        <video class="videoSize" src="../../../../assets/video/bim.mp4" controls></video>
    </div>
</template>

<script>
export default {
    name: 'videoMonitor',

    data() {
        return {
            location: '华中蚌医项目部大门',
            locationOptions: [{ value: '1', label: '华中蚌医项目部大门' }],
        }
    }
}
</script>

<style lang="less" scoped>
.select {
    border: 1px solid #1051CE;
    :global(.el-input__inner) {
        border: 0;
        border-radius: 0;
        color: #ffffff;
        background: linear-gradient(90deg, #06348D 0%, rgba(16,81,206,0.00) 100%)
    }
    :global(.el-icon-arrow-up::before) {
        content: '';
        position: absolute;
        top: 10px;
        right: 5px;
        border-bottom: 10px solid #01FFFD;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
    }
}

.refresh {
    width: 20px;
    height: 20px;
    right: 1.85vh;
    cursor: pointer;
    background: url('../../../../assets/image/homeTemp/refresh.png');
}

.videoSize {
    height: 22vh;
    top: 0.3vh;
}
</style>
